<template>
  <ProductPageLayout
    name="EveryFile"
    :logo="logo"
    :hero-image="heroImage"
    lead="Faster, lighter Windows file search — find files and folders in milliseconds."
    :feature-lines="featureLines"
    download-link="/ftp/packages/everyfile/EveryfileSetup.exe"
    download-file-name="EveryfileSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="Indexed search, multiple views, and smart filters for everyday productivity."
    other-desc="Built for dense folders, media libraries, and project trees."
    reviews-desc="Feedback from real users continuously shapes EveryFile."
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'Everyfile',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/Everyfile/everyfile_48x48.png'),
      heroImage: require('@/assets/Everyfile/详细视图.png'),
      featureLines: [
        'Full-disk search / path filters / keywords / instant jump',
        'List mode / icon mode / favorites / context actions'
      ],
      metaItems: [
        { icon: 'fast', label: 'Instant' },
        { icon: 'search', label: 'Precise' },
        { icon: 'image', label: 'Multi-view' }
      ],
      detailedFeatures: [
        {
          title: 'High-speed index',
          brief: 'Stay fast even with huge libraries.',
          detail: 'Efficient indexing keeps search responsive across documents, media, and deep project trees.',
          image: require('@/assets/Everyfile/列表模式.png')
        },
        {
          title: 'Smart filters',
          brief: 'Combine conditions to narrow results.',
          detail: 'Filter by type, path keywords, and more so you reach the right file without browsing folders.',
          image: require('@/assets/Everyfile/详细视图.png')
        },
        {
          title: 'Multi-view browsing',
          brief: 'Switch list and icon modes freely.',
          detail: 'Use dense text lists for logs, or icon previews for creative assets.',
          image: require('@/assets/Everyfile/中图标.png')
        },
        {
          title: 'Favorites',
          brief: 'Pin frequent folders in one place.',
          detail: 'Keep project roots and tool folders one click away.',
          image: require('@/assets/Everyfile/收藏夹.png')
        }
      ],
      otherFeatures: [
        { title: 'Context menu', description: 'Trigger search from Explorer quickly.', icon: 'mouse' },
        { title: 'Large icon preview', description: 'Browse images and media visually.', icon: 'image' },
        { title: 'Path memory', description: 'Recent paths stay handy for follow-up searches.', icon: 'pin' },
        { title: 'Priority highlight', description: 'Important hits stand out first.', icon: 'sparkle' }
      ],
      reviews: [
        { name: 'Alex', comment: 'Finding logs and configs is dramatically faster.', avatar: require('@/assets/Everyfile/avatar1.jpg') },
        { name: 'Sam', comment: 'Great when teaching materials pile up in nested folders.', avatar: require('@/assets/Everyfile/avatar2.jpg') },
        { name: 'Jordan', comment: 'Saves time hunting assets while writing papers.', avatar: require('@/assets/Everyfile/avatar3.jpg') },
        { name: 'Casey', comment: 'Icon mode helps organize campaign creatives.', avatar: require('@/assets/Everyfile/avatar4.jpg') },
        { name: 'Riley', comment: 'Stable speed; favorites keep common dirs close.', avatar: require('@/assets/Everyfile/avatar5.jpg') },
        { name: 'Morgan', comment: 'Image lookup is smooth for delivery work.', avatar: require('@/assets/Everyfile/avatar6.jpg') }
      ]
    }
  }
}
</script>
